export const EU_GTM_ID = "GTM-5J3FRRC";
export const GLOBAL_GTM_ID = "GTM-J6PG";